import {
    ComponentFactoryResolver, ComponentRef,
    Directive,
    ElementRef, EventEmitter, Input, Output,
    Renderer2,
    ViewContainerRef
} from '@angular/core';
import {CONFIG} from "../app/config";
import {Webster} from "../components/webster/webster";
import {Util} from "../app/util";

@Directive({
    selector: '[webster]'
})
export class WebsterDirective {

    config: any;
    _element: HTMLElement;

    _websterCmpRef: ComponentRef<Webster>;

    @Output('webster-started') websterStarted: EventEmitter<any> = new EventEmitter();  // click somente se não estiver this._requesting

    @Input('webster')
    set websterData(data: any) {

        this.dataSetted(data);

    }

    constructor(element: ElementRef, public renderer: Renderer2, public util: Util,
                private target: ViewContainerRef, private componentFactoryResolver: ComponentFactoryResolver) {

        this.config = CONFIG;
        this._element = element.nativeElement;

    }

    ngAfterViewInit() {

        this.renderer.addClass(this._element, 'corcor-header');
        this.renderer.addClass(this._element, 'corcor-header-webster');

    }

    dataSetted(data: any) {

        if (!this._websterCmpRef) {

            const factory = this.componentFactoryResolver.resolveComponentFactory(Webster);
            this._websterCmpRef = this.target.createComponent(factory, 0);

            const loaderComponentElement = this._websterCmpRef.location.nativeElement;
            const sibling: HTMLElement = loaderComponentElement.previousSibling;

            sibling.insertBefore(loaderComponentElement, sibling.firstChild);

        }

        //this._websterCmpRef.instance.websterData = data;
        this._websterCmpRef.instance.directiveChanged(data);

        let backcolor = this._websterCmpRef.instance.websterData.corBack;
        let fontcolor = this.config.negative(backcolor);

        this._element.style.setProperty('--varBackcolor', this.config.colors[backcolor]);
        this._element.style.setProperty('--varFontcolor', this.config.colors[fontcolor]);

    }

}



// WEBPACK FOOTER //
// ./src/directives/webster.ts